import DefaultNavbar from 'components/DefaultNavbar';
import DefaultFooter from 'components/DefaultFooter';
import WorkingSection from 'components/landing/WorkingSection';
import TeamSection from 'components/landing/TeamSection';
import ContactSection from 'components/landing/ContactSection';
import ScrollTopButton from 'components/landing/ScrollTopButton';
import 'assets/styles/entirePage.css';
import HeaderSection from 'components/HeaderSection';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToSection } from 'components/scrollToSection';


/**
 * The landing page of the website.
 * @returns The landing page with its components.
 */
export default function Landing() {

	const location = useLocation();

	useEffect(() => {
		if(location.hash) {
			scrollToSection(location.hash.substring(1), { duration: 1500 });
		}
	}, [ location ]);

	return (
		<div className='hideOverflow'>
			<div className='absolute w-full z-20'>
				<DefaultNavbar />
			</div>
			<main>
				<HeaderSection
					backgroundClass='landing-background'
					pageTitle='Welcome to Zenith Software!'
					// eslint-disable-next-line max-len
					subtext={'Zenith Software helps businesses bring their ideas to life through cutting-edge, tailored mobile and web app solutions. \n\n We scale your business by walking with you through the entire development process from design to deployment and beyond.'}
				/>
				<WorkingSection />
				<TeamSection />
				<ContactSection />
				<ScrollTopButton />
			</main>
			<DefaultFooter />
		</div>
	);
}
